module.exports = __webpack_public_path__ + "img/checklist_1_ger.3d505753.png";